import GetSchedulerByRoomsRequestModelBase from '../_generated/modelBases/get-scheduler-by-rooms-request-model-base';

export default class GetSchedulerByRoomsRequestModel extends GetSchedulerByRoomsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
